import { render, staticRenderFns } from "./VSelect.vue?vue&type=template&id=f08ae0dc&scoped=true"
import script from "./VSelect.vue?vue&type=script&lang=js"
export * from "./VSelect.vue?vue&type=script&lang=js"
import style0 from "./VSelect.vue?vue&type=style&index=0&id=f08ae0dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08ae0dc",
  null
  
)

export default component.exports